<template>
    <div v-show="isVisible"
         v-if="isVisible"
         :id="['tagForm-' + hotspot.hotspotId]">
        <KeepAlive>
            <component :is="templateForm.template"
                       :store="store"
                       :configuration-data="hotspot.configurationData"
                       :formDescription="hotspot.hotspotAction.lightboxDescription"
                       :formPosition="hotspot.hotspotFormPositions.cssFormPosition"
                       :formRequired="formRequired"
                       :formSizeClass="'small-form-modal-container'"
                       :formTitle="hotspot.hotspotAction.lightboxTitle"
                       :hotspot="getHotspot"
                       :identifierId="hotspot.hotspotId"
                       :key="templateForm._uid"
                       :translateLabels="translateLabels"
                       :typeIdentifier="'hotspot'"
                       @setClose="closeModal"
            ></component>
        </KeepAlive>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { v1 as uuidv1 } from 'uuid';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import templateDefault from './templates/template-default.vue';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS
const props = defineProps({
    hotspot: {
        type: Object,
        required: true,
    },
    translateLabels: {
        type: Object,
        required: true,
    },
});

// REACTIVE VARIABLES
const showImage = ref(true);

// COMPUTED PROPERTIES
const formRequired = computed(() => {
    return props.hotspot.hotspotRequired === false;
});

const getHotspot = computed(() => {
    return props.hotspot ? props.hotspot : null;
});

const isVisible = computed(() => {
    if (!store.getActiveHotspot) {
        return false;
    }
    $('#bottom-button-bar').css({
        opacity: 1, bottom: -50, padding: 0, transition: '0.3s',
    });
    const isThisHotspot = props.hotspot.hotspotId === store.getActiveHotspot.hotspotId;
    const questions = store.getQuestionsByHotspot(props.hotspot.hotspotId, 'small');
    //Evita que se despliegue el formulario si no tiene ninguna pregunta asociada
    if (isThisHotspot && questions.length === 0) {
        closeModal();
        return false;
    }

    return isThisHotspot;
});

const templateForm = computed(() => {
    return {
        template: templateDefault,
        _uid: uuidv1(),
    };
});

// METHODS
const closeModal = () => {
    $('#bottom-button-bar').css({opacity: 1, bottom: -1, transition: '0.3s'});
    store.addActiveHotspot(null);
    store.getPlayer.play();
};

/*const replaceDataVariableInForm = (itemHTML) => {
    const path = store.getPathLocalOrServer;
    const varRegExp = new RegExp(/%%(.*?)%%/g);
    const variables = itemHTML.match(varRegExp);
    if (variables !== null) {
        variables.forEach((variable) => {
            const varRegExp2 = new RegExp(/%%(.*?)%%/g);
            const variableName = variable.match(varRegExp2)[0].replace(/%/g, '');
            if (variableName !== 'animation') {
                if (props.hotspot.imageReference !== null && props.hotspot.imageReference !== '') {
                    itemHTML = itemHTML.replace(variable, path + 'images_variables/' + props.hotspot.imageReference);
                } else {
                    itemHTML = itemHTML.replace(variable, '');
                    showImage.value = false;
                }
            } else {
                if (props.hotspot.hotspotAnimationIn !== '') {
                    itemHTML = itemHTML.replace(variable, props.hotspot.hotspotAnimationIn);
                } else {
                    itemHTML = itemHTML.replace(variable, '');
                }
            }
        });
    }

    return itemHTML;
};*/

// LIFECYCLE HOOKS
// todo: borrar
// onMounted(() => {
//     let questionData = {
//         'id': props.hotspot.hotspotId,
//         'type': 'hotspot',
//         'data': store.getQuestionsByHotspot(props.hotspot.hotspotId, 'small')
//     }
//     store.setFormQuestions(questionData);
// });
</script>
